// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2zBmn","label":"Radio_label__lN3dq","checkMark":"Radio_checkMark__2UfOP","disabled":"Radio_disabled__3C0Yu"};